export default "__VITE_ASSET__C8lZWIaC__"